import Cookies from 'js-cookie'
import { CookieName } from '@/config/cookies'
import { LocaleStorageKey } from '@/config/localeStorageKey'

/**
 * Bootstrap dev session from .env.development.
 * Only needs admin refresh token + target iResa user id — router calls /contact/refresh on load.
 */
export function setLocalDevCookies(): void {
  if (process.env.NODE_ENV === 'production') return

  const userId = process.env.VUE_APP_DEV_USER_ID?.trim()
  const refreshToken = process.env.VUE_APP_DEV_REFRESH_TOKEN?.trim()

  if (!userId || !refreshToken) return

  Cookies.set(CookieName.USER_ID, userId)
  Cookies.set(CookieName.REFRESH_TOKEN, refreshToken)
  localStorage.setItem(LocaleStorageKey.USER_ID, userId)

  const company = process.env.VUE_APP_DEV_COMPANY?.trim()
  if (company) {
    Cookies.set(CookieName.COMPANY, company)
  }

  console.info('[dev] Local session bootstrap for user', userId)
}
